<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <div class="item-son" v-if="searchShow">
            <el-input
                clearable
                v-model="listParams.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                style="width: 180px"
                @keyup.enter.native="SearchServiceList"
            ></el-input>
            <el-select
                v-model="listParams.bankId"
                clearable
                placeholder="请选择类型"
                style="width: 180px;margin: 0 10px"
            >
              <el-option :key="index" v-for="(item,index) in typeData" :label="item.name" :value="item.bankId"></el-option>
            </el-select>
            <el-select
                v-model="listParams.status"
                clearable
                placeholder="请选择状态"
                style="width: 180px"
            >
              <el-option label="正常" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </div>
          <div class="item-son" v-if="searchShow">
            <el-button type="primary" @click="queryTableData"
            >查询 <i class="el-icon-search"></i>
            </el-button>
          </div>
          <div class="item-son" v-if="addShow">
            <el-button type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="public-table-data">
      <el-table
          ref="multipleTable"
          size="medium"
          :data="tableData"
          border
          style="width: 100%"
          row-key="menuId"
          v-loading="loading"
      >
        <el-table-column align="center" fixed label="序号" type="index" width="100">
          <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="typeName" label="类型" width="160" align="center">
          <template slot-scope="scope">
            <div class="bank_box" v-if="scope.row.bank">
              <img :src="scope.row.bank.icon"><span>{{scope.row.bank.name}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" width="200" align="center">
        </el-table-column>
        <el-table-column prop="account" label="账号" width="160" align="center">
        </el-table-column>
        <el-table-column prop="descr" label="说明" width="200" align="center">
        </el-table-column>
        <el-table-column prop="seq" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column prop="code" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <template>
              <el-switch
                  :disabled="statusShow"
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="changeSwitch(scope.row)"
              >
              </el-switch>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" min-width="150">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleClick('edit', scope.row)"
                type="warning"
                plain
                v-if="editShow"
            >编辑
            </el-button
            >
            <el-button
                v-if="deleteShow"
                size="mini"
                @click="handleDelete(scope.row)"
                type="primary"
                plain
            >删除
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="roleRight_pagenation" style="padding: 30px 0 20px;text-align: center">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNo"
          :page-sizes="[PAGE_SIZE, 15, 20, 25]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.count"
      >
      </el-pagination>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑支付类型"
        :visible.sync="dialogVisible"
        width="460px"
        :close-on-click-modal="false"
        class="public-dialog "
    >
      <div class="public-dialog-form xq_checkColor">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item label="类型" prop="bankId">
            <el-select
                v-model="params.bankId"
                clearable
                placeholder="请选择类型"
                style="width: 130px"
            >
              <el-option :key="index" v-for="(item,index) in typeData" :label="item.name" :value="item.bankId"></el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-form-item label="名称" prop="name">
                <el-input
                    placeholder="请填写名称"
                    v-model="params.name"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="账号" prop="account">
            <el-input
                placeholder="请填写账号"
                type="number"
                v-model="params.account"
            ></el-input>
          </el-form-item>
          <el-form-item label="说明">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入说明"
                v-model="params.descr"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="排序" prop="seq">
            <el-input
                type="number"
                placeholder="请填写排序序号"
                v-model.number="params.seq"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {PAGE_SIZE, FILE_ROOT, JOB_STATUS} from "@config";
import {ossUpload} from "@utils/filters/upload";
import {isEmpty} from "../../utils/tools";
import OperationConfirmation from "../../components/OperationConfirmation";

export default {
  components: {OperationConfirmation},
  data() {
    return {
      PAGE_SIZE,
      isEmpty,
      tableData: [],
      typeData:[],
      listParams: {},
      params: {},
      dialogVisible: false,
      total: 0,
      loading: false,
      clickType: "",
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      rules: {
        bankId: [
          {required: true, message: "请选择类型", trigger: "change"},
        ],
        name: [
          {required: true, message: "请填写名称", trigger: "change"},
        ],
        account: [
          {required: true, message: "请填写账号", trigger: "change"},
        ],
      },

      srcList: [],
      isMoer: true,
      imgLoading: false,
      numType: false,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
    };
  },
  mounted() {
    this.queryTypeTableData()
    this.queryTableData();
    this.getPermissionButtonList()
  },
  computed: {},
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.srcList = [];
        this.isMoer = true;
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'finance:capital:query') {
            this.searchShow = true
          }
          if (item.code == 'finance:capital:add') {
            this.addShow = true
          }
          if (item.code == "finance:capital:delete") {
            this.deleteShow = true
          }
          if (item.code == "finance:capital:edit") {
            this.editShow = true
          }
          if (item.code == "finance:capital:status") {
            this.statusShow = false
          }
        })
      }
    },
    /**
     * 获取类型列表
     */
    async queryTypeTableData() {
      this.loading = true;
      const {data: resData} = await this.$get("/bank/list?paging=false");
      this.loading = false;
      if (resData.result != 200) return;
      this.typeData = resData.data;
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;
      const {data: resData} = await this.$get("/bank/account/list", {
        params: {
          ...this.listParams,
          ...this.page,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.page.count = resData.page.count;
    },
    /**
     * 修改支付类型状态
     */
    async changeSwitch(b) {
      const {data: resData} = await this.$put(
          `/bank/account/info/status/${b.bankAccountId}`
      );
      if (resData.result != 200) return;
      this.$message.success('操作成功')
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "edit") {
        //编辑
        const {data: resData} = await this.$get(
            `/bank/account/info/${row.bankAccountId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.params = resData.data;
        if (!isEmpty(this.params.icon)) {
          this.srcList[0] = this.params.icon;
          this.isMoer = false;
        }
        this.dialogVisible = true;
      }
      if (type == "add") {
        this.params = {};
        this.dialogVisible = true;
      }
    },

    //查询
    SearchServiceList() {
      this.page.pageNo = 1
      delete this.page['count']
      this.getserviceList()
    },
    /**
     * 编辑/增加
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add" || this.clickType == "addNext") {
            const {data: resData} = await this.$post(
                "/bank/account/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;
            this.queryTableData();
            this.dialogVisible = false;
            this.$message.success("添加成功!");
            this.params = {};
          } else {
            const {data: resData} = await this.$put(
                "/bank/account/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.queryTableData();
            this.dialogVisible = false;
            this.$message.success("修改成功!");
          }
        });
      });
    },

    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/bank/account/info/${row.bankAccountId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.queryTableData();
      });
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
    /**
     * 阿里云OSS签名
     */
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      this.imgLoading = true;
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign");
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one" //'more','one'
      );
      this.imgLoading = false;
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
    },

  },
};
</script>
<style lang="scss" scoped>
.icon-width {
  width: 20px;
  height: 20px;
  display: inline-block;
}

.screenshot {
  position: relative;
}

.xq_checkColor {
  ::v-deep .el-color-picker__trigger {
    width: 60px !important;
    height: 60px !important;
  }
}

.bank_box{
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    width: 40px;
    height: 40px;
    object-fit: contain;
    margin-right: 10px;
  }
}
</style>